import { render, staticRenderFns } from "./CoreActivities.vue?vue&type=template&id=72fd70ac&scoped=true"
import script from "./CoreActivities.vue?vue&type=script&lang=js"
export * from "./CoreActivities.vue?vue&type=script&lang=js"
import style0 from "./CoreActivities.vue?vue&type=style&index=0&id=72fd70ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd70ac",
  null
  
)

export default component.exports